import { render, staticRenderFns } from "./Top5Findings.vue?vue&type=template&id=3e616613&scoped=true&"
import script from "./Top5Findings.vue?vue&type=script&lang=js&"
export * from "./Top5Findings.vue?vue&type=script&lang=js&"
import style0 from "./Top5Findings.vue?vue&type=style&index=0&id=3e616613&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e616613",
  null
  
)

export default component.exports